<div class="wrapper">
  <h1 class="title">{{name | titlecase}}</h1>
  <app-error-summary [error]="error" *ngIf="error"></app-error-summary>
  <mat-form-field appearance="outline" class="form__field">
    <mat-label>YouTube Embed URL</mat-label>
    <input matInput [(ngModel)]="videoUrl" placeholder="https://www.youtube.com/embed/..." />
  </mat-form-field>
  <div style="margin-top: 10px;">
    <button mat-button color="primary" (click)="onSave()">Update Video</button>
  </div>
</div>
